import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Button, Form, Spinner, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import ErrorModal from "./ErrorModal";
import { FaAddressCard, FaMapMarkerAlt, FaFileInvoice, FaUser } from "react-icons/fa";

const BoardMyData = ({ embedded = false }) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    custumer_company_name: '',
    custumer_contact_firstname: '',
    custumer_contact_lastname: '',
    custumer_contact_mobile: '',
    custumer_postal_code: '',
    custumer_city: '',
    custumer_city_add: '',
    custumer_str: '',
    custumer_street_number: '',
    custumer_street_add: '',
    custumer_tax_number: '',
    custumer_tax_id: '',
    custumer_company_email: '',
  });

  const [responseData, setResponseData] = useState({
    t_customer: {
      t_place_id: {
        t_services: {},
      },
    },
    t_tariffs: {},
    // other fields you expect in responseData
  });
  const [errors, setErrors] = useState({});
  const [apiErrors, setApiErrors] = useState(null);
  const [apiErrorCode, setApiErrorCode] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Loading, please wait...');
  const [showModal, setShowModal] = useState(false);
  

  // Fetch customer data when the component mounts
  useEffect(() => {
    setLoading(true); // Start loading

    UserService.getCustomerBoard()
      .then((response) => {
        setResponseData(response.data[0]);
        setFormData(response.data[0].t_customer);
      })
      .catch((error) => handleError(error))
      .finally(() => setLoading(false));

      
  }, []);

  const handleError = (error) => {
    if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
    if (error.response) {
      setApiErrors(`Fehler: ${error.response.data.message}`);
      setApiErrorCode(`Fehler: ${error.name} – ${error.response.status}`);
    } else if (error.request) {
      setApiErrors('Keine Antwort vom Server.');
      setApiErrorCode(`Fehler: ${error.name}`);
    } else {
      setApiErrors(`Fehler: ${error.message}`);
      setApiErrorCode(`Fehler: ${error.name}`);
    }
  
    setLoading(false);
    setSuccessMessage(null);
    setShowModal(true);
  };

  const handleBlur = () => {
    validateForm();
 };
  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };

  const validateForm = () => {
    const newErrors = {};
    
    // Validate company_name
    if (!formData.custumer_company_name.trim()) {
      newErrors.custumer_company_name = 'Firmenname ist erforderlich';
    }
  
    // Validate company_mobile_number (example: must be a valid phone number)
    if (!formData.custumer_contact_mobile.trim()) {
      newErrors.custumer_contact_mobile = 'Mobilnummer ist erforderlich';
    } else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.custumer_contact_mobile)) {
      newErrors.custumer_contact_mobile = 'Bitte eine gültige Telefonnummer eingeben';
    }
  
    // Validate company_email (example: must be a valid email)
    if (!formData.custumer_company_email.trim()) {
      newErrors.custumer_company_email = 'Firmen-E-Mail ist erforderlich';
    } else if (!/\S+@\S+\.\S+/.test(formData.custumer_company_email)) {
      newErrors.custumer_company_email = 'Bitte eine gültige E-Mail-Adresse eingeben';
    }
  
    // Validate contact_first_name
    if (!formData.custumer_contact_firstname.trim()) {
      newErrors.custumer_contact_firstname = 'Vorname ist erforderlich';
    }
  
    // Validate contact_last_name
    if (!formData.custumer_contact_lastname.trim()) {
      newErrors.custumer_contact_lastname = 'Nachname ist erforderlich';
    }
  
   // Validate custumer_postal_code
   if (!formData.custumer_postal_code.trim()) {
    newErrors.custumer_postal_code = 'Postleitzahl ist erforderlich';
  } else if (!/^\d{5}$/.test(formData.custumer_postal_code)) {
    newErrors.custumer_postal_code = 'Die Postleitzahl muss aus 5 Ziffern bestehen';
  }

  // Validate custumer_city
  if (!formData.custumer_city.trim()) {
    newErrors.custumer_city = 'Ort ist erforderlich';
  }

  // Validate custumer_city_add (optional field, no trim)
  if (formData.custumer_city_add && !formData.custumer_city_add.trim()) {
    newErrors.custumer_city_add = 'Der Ortszusatz darf nicht leer sein';
  }

  // Validate custumer_str (Street)
  if (!formData.custumer_str.trim()) {
    newErrors.custumer_str = 'Straße ist erforderlich';
  }

  // Validate custumer_street_number
  if (!formData.custumer_street_number.trim()) {
    newErrors.custumer_street_number = 'Hausnummer ist erforderlich';
  } else if (!/^\d+$/.test(formData.custumer_street_number)) {
    newErrors.custumer_street_number = 'Bitte eine gültige Hausnummer eingeben';
  }

  // Validate custumer_street_add (optional field, no trim)
  if (formData.custumer_street_add && !formData.custumer_street_add.trim()) {
    newErrors.custumer_street_add = 'Der Adresszusatz darf nicht leer sein';
  }

  // Validate custumer_tax_number (optional validation)
  if (formData.custumer_tax_number && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_number)) {
    newErrors.custumer_tax_number = 'Die Steuernummer darf nur Buchstaben und Ziffern enthalten';
  }

  // Validate custumer_tax_id (optional validation)
  if (formData.custumer_tax_id && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_id)) {
    newErrors.custumer_tax_id = 'Die Umsatzsteuer-ID darf nur Buchstaben und Ziffern enthalten';
  }


    if(currentUser.roles.includes("ROLE_ADMIN") )
    {
    // Validate Sub VO ID
    if (!formData.t_sub_vo.sub_vo_id || isNaN(formData.t_sub_vo.sub_vo_id)) {  
      newErrors.sub_vo_id = 'Bitte einen Vertriebspartner auswählen.';
    } else if (parseInt(formData.t_sub_vo.sub_vo_id) <= 0) {
      newErrors.sub_vo_id = 'Die Nummer des Vertriebspartners muss größer als 0 sein.';
    }
    }
    // Extended Validation for New Fields
  
    // Validate custumer_postal_code
    if (!formData.custumer_postal_code.trim()) {
      newErrors.custumer_postal_code = 'Postleitzahl ist erforderlich';
    } else if (!/^\d{5}$/.test(formData.custumer_postal_code)) {
      newErrors.custumer_postal_code = 'Die Postleitzahl muss aus 5 Ziffern bestehen';
    }
  
    // Validate custumer_city
    if (!formData.custumer_city.trim()) {
      newErrors.custumer_city = 'Ort ist erforderlich';
    }
  
    // Validate custumer_city_add (optional field, no trim)
    if (formData.custumer_city_add && !formData.custumer_city_add.trim()) {
      newErrors.custumer_city_add = 'Der Ortszusatz darf nicht leer sein';
    }
  
    // Validate custumer_str (Street)
    if (!formData.custumer_str.trim()) {
      newErrors.custumer_str = 'Straße ist erforderlich';
    }
  
    // Validate custumer_street_number
    if (!formData.custumer_street_number.trim()) {
      newErrors.custumer_street_number = 'Hausnummer ist erforderlich';
    } else if (!/^\d+$/.test(formData.custumer_street_number)) {
      newErrors.custumer_street_number = 'Bitte eine gültige Hausnummer eingeben';
    }
  
    // Validate custumer_street_add (optional field, no trim)
    if (formData.custumer_street_add && !formData.custumer_street_add.trim()) {
      newErrors.custumer_street_add = 'Der Adresszusatz darf nicht leer sein';
    }
  
    // Validate custumer_tax_number (optional validation)
    if (formData.custumer_tax_number && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_number)) {
      newErrors.custumer_tax_number = 'Die Steuernummer darf nur Buchstaben und Ziffern enthalten';
    }
  
    // Validate custumer_tax_id (optional validation)
    if (formData.custumer_tax_id && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_id)) {
      newErrors.custumer_tax_id = 'Die Umsatzsteuer-ID darf nur Buchstaben und Ziffern enthalten';
    }
  
    if (newErrors.custumer_str || newErrors.custumer_street_number || newErrors.custumer_street_add || newErrors.custumer_postal_code || newErrors.custumer_city || newErrors.custumer_city_add) {
      setActiveTab("adresse");
    } else if (newErrors.custumer_tax_number || newErrors.custumer_tax_id) {
      setActiveTab("steuer");
    } else if (Object.keys(newErrors).length > 0) {
      setActiveTab("kontakt");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("handle Submit");
    if (validateForm()) {
        setLoadingText(' Updating the data please wait...');
      setLoading(true);
      // Assuming UserService.updateCustomer is an API method to update customer data
    UserService.updateCustomerBoard(formData.customer_id,formData)
        .then(() => {
          setSuccessMessage('Ihre Daten wurden gespeichert.');
          setApiErrors(null); // Clear any previous API errors
          setLoading(false);
        })
        .catch((error) => handleError(error))
    }
  };

  const handleCloseModal = () => setShowModal(false);
  const [activeTab, setActiveTab] = useState("kontakt");
  const tabs = [
    { id: "kontakt", label: "Kontakt", icon: <FaUser aria-hidden="true" /> },
    { id: "adresse", label: "Adresse", icon: <FaMapMarkerAlt aria-hidden="true" /> },
    { id: "steuer", label: "Steuer", icon: <FaFileInvoice aria-hidden="true" /> },
  ];

  return (
    <section className="myn-sheet">
      {!embedded && (
        <header className="myn-sheet__head">
          <span className="myn-sheet__icon" aria-hidden="true"><FaAddressCard /></span>
          <div>
            <p className="myn-sheet__kicker">Stammdaten</p>
            <h1 className="myn-sheet__title">Meine Daten</h1>
            <p className="myn-sheet__lead">Hier pflegen Sie Kontaktdaten, Anschrift und Steuerangaben für Ihre Rechnungen. QR-Codes, Tarife und die Zieladresse der Google-Bewertung stellen Sie unter Meine QR-Codes ein.</p>
          </div>
        </header>
      )}
      {embedded && (
        <p className="myn-sheet__lead">Hier pflegen Sie Kontaktdaten, Anschrift und Steuerangaben für Ihre Rechnungen. QR-Codes, Tarife und die Zieladresse der Google-Bewertung stellen Sie unter Meine QR-Codes ein.</p>
      )}
      <div className="myn-sheet__tabs" role="tablist" aria-label="Stammdaten">
        {tabs.map((tab) => (
          <button key={tab.id} type="button" role="tab" aria-selected={activeTab === tab.id} className={activeTab === tab.id ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setActiveTab(tab.id)}>
            {tab.icon}<span>{tab.label}</span>
          </button>
        ))}
      </div>
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={apiErrorCode} errorMessage={apiErrors} />
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
      {loading ? (
        <p className="myn-sheet__muted"><Spinner animation="border" size="sm" /> Kundendaten werden geladen …</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          {activeTab === "kontakt" && (
            <div className="myn-sheet__panel">
              <Form.Group controlId="formCompanyName">
                <Form.Label>Firmenname</Form.Label>
                <Form.Control type="text" name="custumer_company_name" value={formData.custumer_company_name || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_company_name} />
                <Form.Control.Feedback type="invalid">{errors.custumer_company_name}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formContactFirstName" className="mt-3">
                <Form.Label>Vorname</Form.Label>
                <Form.Control type="text" name="custumer_contact_firstname" value={formData.custumer_contact_firstname || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_contact_firstname} />
                <Form.Control.Feedback type="invalid">{errors.custumer_contact_firstname}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formContactLastName" className="mt-3">
                <Form.Label>Nachname</Form.Label>
                <Form.Control type="text" name="custumer_contact_lastname" value={formData.custumer_contact_lastname || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_contact_lastname} />
                <Form.Control.Feedback type="invalid">{errors.custumer_contact_lastname}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formContactMobile" className="mt-3">
                <Form.Label>Mobilnummer</Form.Label>
                <Form.Control type="text" name="custumer_contact_mobile" value={formData.custumer_contact_mobile || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_contact_mobile} />
                <Form.Control.Feedback type="invalid">{errors.custumer_contact_mobile}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formCompanyEmail" className="mt-3">
                <Form.Label>Firmen-E-Mail</Form.Label>
                <Form.Control type="email" name="custumer_company_email" value={formData.custumer_company_email || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_company_email} />
                <Form.Control.Feedback type="invalid">{errors.custumer_company_email}</Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
          {activeTab === "adresse" && (
            <div className="myn-sheet__panel">
              <Form.Group controlId="formStreet">
                <Form.Label>Straße</Form.Label>
                <Form.Control type="text" name="custumer_str" value={formData.custumer_str || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_str} />
                <Form.Control.Feedback type="invalid">{errors.custumer_str}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formStreetNumber" className="mt-3">
                <Form.Label>Hausnummer</Form.Label>
                <Form.Control type="text" name="custumer_street_number" value={formData.custumer_street_number || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_street_number} />
                <Form.Control.Feedback type="invalid">{errors.custumer_street_number}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formStreetAdd" className="mt-3">
                <Form.Label>Adresszusatz</Form.Label>
                <Form.Control type="text" name="custumer_street_add" value={formData.custumer_street_add || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_street_add} />
                <Form.Control.Feedback type="invalid">{errors.custumer_street_add}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formPostalCode" className="mt-3">
                <Form.Label>Postleitzahl</Form.Label>
                <Form.Control type="text" name="custumer_postal_code" value={formData.custumer_postal_code || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_postal_code} />
                <Form.Control.Feedback type="invalid">{errors.custumer_postal_code}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formCity" className="mt-3">
                <Form.Label>Ort</Form.Label>
                <Form.Control type="text" name="custumer_city" value={formData.custumer_city || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_city} />
                <Form.Control.Feedback type="invalid">{errors.custumer_city}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formCityAdd" className="mt-3">
                <Form.Label>Ortszusatz</Form.Label>
                <Form.Control type="text" name="custumer_city_add" value={formData.custumer_city_add || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_city_add} />
                <Form.Control.Feedback type="invalid">{errors.custumer_city_add}</Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
          {activeTab === "steuer" && (
            <div className="myn-sheet__panel">
              <Form.Group controlId="formTaxNumber">
                <Form.Label>Steuernummer</Form.Label>
                <Form.Control type="text" name="custumer_tax_number" value={formData.custumer_tax_number || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_tax_number} />
                <Form.Control.Feedback type="invalid">{errors.custumer_tax_number}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formTaxID" className="mt-3">
                <Form.Label>Umsatzsteuer-ID</Form.Label>
                <Form.Control type="text" name="custumer_tax_id" value={formData.custumer_tax_id || ""} onChange={handleChange} onBlur={handleBlur} isInvalid={!!errors.custumer_tax_id} />
                <Form.Control.Feedback type="invalid">{errors.custumer_tax_id}</Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
          <Button className="myn-btn myn-btn--primary myn-btn--block mt-3" type="submit">Speichern</Button>
        </Form>
      )}
    </section>
  );
};

export default BoardMyData;
